export default (select, options) => {
  while (select.options.length > 0) {
    select.remove(0);
  }

  select.appendChild(createOption("", ""));

  options.forEach((option) => {
    const newOption = createOption(option.id, option.name);
    select.appendChild(newOption);
  });
};

const createOption = (id, name) => {
  const newOption = document.createElement("option");
  const optionText = document.createTextNode(name);
  // set option text
  newOption.appendChild(optionText);
  newOption.setAttribute("value", id);

  return newOption;
};
